import { createContext } from 'react';

export const JsonFormContext = createContext(null);